import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PermissionsService } from '../../../services/permissions.service';

export type EmploymentAvailabilityWorkingJobDialogData = {
  availabilityId: string;
  startDate: string;
  endDate: string;
  personName: string;
  organisationName: string;
  departmentName: string;
  unavailabilities?: {
    from: string;
    to: string;
    reason: string;
  }[];
  isOwnBooked?: boolean;
};

@Component({
  selector: 'temp-work-edit-availability-dialog',
  templateUrl: 'employment-availability-working-job-dialog.html',
  styleUrls: ['employment-availability-working-job-dialog.scss'],
})
export class EmploymentAvailabilityWorkingJobDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<EmploymentAvailabilityWorkingJobDialogComponent>,
    public permissionsService: PermissionsService,
    @Inject(MAT_DIALOG_DATA)
    public data: EmploymentAvailabilityWorkingJobDialogData,
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
